module.exports = __webpack_public_path__ + "img/MG-ZS-EV-D.a1da1c45.png";